import { useTranslation } from 'next-i18next'

import { SectionEditButton } from 'components/buttons'

import { orderEducationExperience } from 'utils/orderExperience'

import { ICVEducationHistoryProps } from './types'

const CVEducationHistory = ({
  educationHistory,
  editable,
  onEdit
}: ICVEducationHistoryProps) => {
  const { t } = useTranslation(['cv_modal', 'cv_form'])
  return (
    <div className="py-5">
      <div className="flex items-center justify-between">
        <h2 className="pb-6 text-2xl font-bold tracking-wide">
          {t('fields.educationHistory', { ns: 'cv_modal' })}
          <i className="dot"></i>
        </h2>
        {editable && (
          <SectionEditButton
            data-cy="education-add-modal"
            variant="add"
            onClick={() => onEdit?.(-1)}
          />
        )}
      </div>
      {orderEducationExperience(educationHistory).map((edu, index: number) => (
        <div key={index} className="relative flex items-start">
          <div className="mr-5 flex h-full flex-col items-center justify-between md:hidden">
            <div className="mt-2 h-[6px] w-[6px] overflow-hidden rounded-full bg-black"></div>
            {educationHistory?.length != index + 1 && (
              <div className="mr-[0.75px] flex-1 before:absolute before:bottom-0 before:h-[calc(100%_-_18px)] before:w-[1px] before:bg-gray-200"></div>
            )}
          </div>
          <div className="relative flex w-full flex-col items-start md:flex-row">
            <div className="flex-[2] text-base font-bold tracking-wider md:text-sm">
              {new Date(edu?.startDate).getFullYear()} -&nbsp;
              {edu.endDate
                ? new Date(edu?.endDate).getFullYear()
                : t('cv_form:date.now')}
            </div>
            <div className="mx-5 hidden h-full flex-col items-center justify-between md:flex">
              <div className="mt-2 h-[6px] w-[6px] overflow-hidden rounded-full bg-black "></div>
              {educationHistory?.length !== index + 1 && (
                <div className="mr-[0.75px] flex-1 before:absolute before:bottom-0 before:h-[calc(100%_-_18px)] before:w-[1px] before:bg-gray-200"></div>
              )}
            </div>
            <div className="flex-[8] pb-5 text-lg md:text-base">
              <div className="pb-2 font-semibold">
                <span className="mr-3">{edu.organisationName}</span>
                {editable && (
                  <SectionEditButton
                    data-cy="education-edit-modal"
                    isPlain
                    onClick={() => onEdit?.(index)}
                  />
                )}
              </div>
              <div className="font-normal">
                {edu.degree}, {edu.fieldOfStudy}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default CVEducationHistory
